export default __webpack_public_path__ + "static/hw_potentiometer-3413ae887bd4411ce8a34fd616b7f9f3.jpg";